import { IconProps } from './IconProps';

export const Check = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="116"
      height="116"
      viewBox="0 0 116 116"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.0078 0C26.1772 0 0.323059 25.8503 0.323059 57.6808C0.323059 89.5113 26.1772 115.35 58.0078 115.35C89.8383 115.35 115.677 89.5113 115.677 57.6808C115.677 25.8503 89.8383 0 58.0078 0ZM58.0078 3.97772C87.6886 3.97772 111.699 28 111.699 57.6808C111.699 87.3616 87.6886 111.372 58.0078 111.372C28.327 111.372 4.30466 87.3616 4.30466 57.6808C4.30466 28 28.327 3.97772 58.0078 3.97772ZM84.7836 36.1141C84.2575 36.1498 83.7671 36.3929 83.4201 36.79L50.4175 74.388L32.475 57.3157C32.2854 57.1352 32.0621 56.9939 31.8179 56.8999C31.5736 56.8059 31.3132 56.7611 31.0516 56.7679C30.79 56.7748 30.5322 56.8332 30.2932 56.9398C30.0542 57.0464 29.8386 57.1992 29.6588 57.3893C29.4783 57.5789 29.337 57.8022 29.243 58.0465C29.149 58.2907 29.1042 58.5512 29.1111 58.8128C29.1179 59.0744 29.1763 59.3321 29.283 59.5711C29.3897 59.8101 29.5424 60.0258 29.7326 60.2056L49.1861 78.6919C49.3794 78.8768 49.6079 79.0209 49.8581 79.1155C50.1083 79.2101 50.3751 79.2532 50.6423 79.2424C50.9096 79.2315 51.1719 79.1668 51.4136 79.0522C51.6553 78.9376 51.8714 78.7754 52.049 78.5754L86.4034 39.4042C86.7512 39.0084 86.9278 38.4907 86.8943 37.9649C86.8608 37.4391 86.62 36.948 86.2248 36.5996C85.8277 36.2532 85.3093 36.0787 84.7836 36.1141Z"
        fill="#057FF0"
      />
    </svg>
  );
};

